import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "b-free-credits p-product-home--layout-vertical-offset"
}
const _hoisted_2 = { class: "p-product-home--layout-offset" }
const _hoisted_3 = { class: "p-product-home--layout" }
const _hoisted_4 = { class: "flex between-xs" }
const _hoisted_5 = { class: "p-product-home--layout-title bold black" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "€50", -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "b-free-credits__image flex middle-xs center-xs" }
const _hoisted_9 = ["alt"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "medium center-xs" }, "€50", -1)
const _hoisted_11 = {
  key: 0,
  style: {"margin-top":"16px"}
}
const _hoisted_12 = { class: "p-home__content" }
const _hoisted_13 = {
  key: 0,
  class: "p-home__steps p-product-home--layout-vertical-offset"
}
const _hoisted_14 = { class: "p-product-home--layout-offset" }
const _hoisted_15 = { class: "p-product-home--layout" }
const _hoisted_16 = { class: "p-product-home--layout-title bold black" }
const _hoisted_17 = { class: "p-product-home--layout-subtitle regular grey" }
const _hoisted_18 = { class: "p-home__steps__content" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-xs-12 col-sm-4" }
const _hoisted_21 = { class: "p-home__steps_item flex" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    width: "48",
    height: "48",
    src: "/static/img/search-icon.svg",
    alt: ""
  })
], -1)
const _hoisted_23 = { class: "step-content" }
const _hoisted_24 = { class: "medium bold" }
const _hoisted_25 = { class: "regular grey" }
const _hoisted_26 = { class: "col-xs-12 col-sm-4" }
const _hoisted_27 = { class: "p-home__steps_item flex" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    width: "48",
    height: "48",
    src: "/static/img/book-icon.svg",
    alt: ""
  })
], -1)
const _hoisted_29 = { class: "step-content" }
const _hoisted_30 = { class: "medium bold" }
const _hoisted_31 = { class: "regular grey" }
const _hoisted_32 = { class: "col-xs-12 col-sm-4" }
const _hoisted_33 = { class: "p-home__steps_item flex" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    width: "48",
    height: "48",
    src: "/static/img/stay-icon.svg",
    alt: ""
  })
], -1)
const _hoisted_35 = { class: "step-content" }
const _hoisted_36 = { class: "medium bold" }
const _hoisted_37 = { class: "regular grey" }
const _hoisted_38 = { class: "p-home__popular-destinations p-product-home--layout-vertical-offset" }
const _hoisted_39 = { class: "p-product-home--layout-offset" }
const _hoisted_40 = { class: "p-product-home--layout" }
const _hoisted_41 = { class: "p-home__chains p-product-home--layout-vertical-offset" }
const _hoisted_42 = { class: "p-product-home--layout-offset" }
const _hoisted_43 = { class: "p-product-home--layout" }
const _hoisted_44 = { class: "p-product-home--layout-title bold black" }
const _hoisted_45 = { class: "p-product-home--layout-subtitle regular grey" }
const _hoisted_46 = { class: "p-home__chains_carousel" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "fst-row row between-xs" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-xs flex middle-xs" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "hilton",
      src: "/static/img/hilton-logo.svg",
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-xs flex middle-xs" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "marriott",
      src: "/static/img/marriott-logo.svg",
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-xs flex middle-xs" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "radisson",
      src: "/static/img/radisson-logo.svg",
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-xs flex middle-xs" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "ihg",
      src: "/static/img/ihg-logo.svg",
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-xs flex middle-xs" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "starwood",
      src: "/static/img/starwood-logo.svg",
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-xs flex middle-xs" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "hayatt",
      src: "/static/img/hayatt-logo.svg",
      alt: ""
    })
  ])
], -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "sec-row row between-xs" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-xs flex middle-xs" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/static/img/wyndham-logo.svg",
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-xs flex middle-xs" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/static/img/fairmont-logo.svg",
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-xs flex middle-xs" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/static/img/accorhotels-logo.svg",
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-xs flex middle-xs" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/static/img/bestwestern-logo.svg",
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-xs flex middle-xs" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/static/img/ramada-logo.svg",
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-xs flex middle-xs" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/static/img/courtyard-logo.svg",
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-xs flex middle-xs" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/static/img/choicehotels-logo.svg",
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-xs flex middle-xs" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/static/img/mgmresorts-logo.svg",
      alt: ""
    })
  ])
], -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "thr-row row between-xs" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-xs flex middle-xs" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/static/img/omni-logo.svg",
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-xs flex middle-xs" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/static/img/ritzcarlton-logo.svg",
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-xs flex middle-xs" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/static/img/waldorfastoria-logo.svg",
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-xs flex middle-xs" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/static/img/fourseasons-logo.svg",
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-xs flex middle-xs" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/static/img/intercontinental-logo.svg",
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-xs flex middle-xs" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/static/img/jwmarriott-logo.svg",
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-xs flex middle-xs" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/static/img/shangrila-logo.svg",
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-xs flex middle-xs" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/static/img/melia-logo.svg",
      alt: ""
    })
  ])
], -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "frt-row row between-xs" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-xs flex middle-xs" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/static/img/laquinta-logo.svg",
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-xs flex middle-xs" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/static/img/doubletree-logo.svg",
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-xs flex middle-xs" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/static/img/comfortinnn-logo.svg",
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-xs flex middle-xs" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/static/img/renaissance-logo.svg",
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-xs flex middle-xs" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/static/img/clarion-logo.svg",
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-xs flex middle-xs" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/static/img/crowneplaza-logo.svg",
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-xs flex middle-xs" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/static/img/hampton-logo.svg",
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-xs flex middle-xs" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/static/img/novotel-logo.svg",
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-xs flex middle-xs" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/static/img/daysinn-logo.svg",
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-xs flex middle-xs" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/static/img/holidayinn-logo.svg",
      alt: ""
    })
  ])
], -1)

import { computed } from 'vue';
  import { useStore } from 'vuex';
  import { useI18n } from 'vue-i18n';
  import { parse, format } from 'date-fns';
  import { HotelSearchCriteria, User } from '@/types';
  import { lazyComponent } from '@/router/routes';
  import PopularDestinationsContainerComponent from '@/views/components/HomePages/PopularDestinationsContainerComponent.vue';
  import DataSecureDescriptionComponent from '@/views/components/HomePages/DataSecureDescriptionComponent.vue';
  import { EffectFade, Autoplay } from 'swiper/modules';
  import { Swiper, SwiperSlide } from 'swiper/vue';
  import 'swiper/css';
  import 'swiper/css/effect-fade';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'HomeContent',
  setup(__props) {

  const FooterComponent = lazyComponent('FooterComponent');
  const ButtonComponent = lazyComponent('ButtonComponent');

  const store = useStore();
  const { t } = useI18n();

  const isMobile = computed<boolean>(() => store.state.support.isMobile);
  const isAppView = computed<boolean>(() => store.state.support.isAppView);
  const userV2 = computed<User.UserV2>(() => store.state.user.userV2);
  const userCategory = computed<User.UserCategory.Category>(
    () => store.state.user.category,
  );
  const searchCriteria = computed<HotelSearchCriteria>(
    () => store.state.searchCriteria.criteria,
  );

  const baseQuery = computed(() => {
    const query = {
      in: format(parse(searchCriteria.value.checkin), 'YYYY-MM-DD'),
      out: format(parse(searchCriteria.value.checkout), 'YYYY-MM-DD'),
      guests: String(searchCriteria.value.adults),
    };
    const children = searchCriteria.value.children.filter(
      it => typeof it === 'number',
    );

    if (children.length > 0) {
      query['childs'] = children.join(',');
    }

    return query;
  });

  const destinations = computed(() => {
    return [
      {
        link: {
          path: `/search/G51.507,-0.128`,
          query: {
            ...baseQuery.value,
            d: 'London',
            type: 'city',
            lat: '51.507',
            lon: '-0.127',
            city: 'London',
            state: 'Greater London',
            country: 'GB',
          },
        },
        image: '/static/img/London.jpg',
        title: t('mainpage.popularDestinations.destinations.London'),
      },
      {
        link: {
          path: `/search/G40.417,-3.703`,
          query: {
            ...baseQuery.value,
            d: 'Madrid',
            type: 'city',
            lat: '40.417',
            lon: '-3.703',
            city: 'Madrid',
            state: 'Community of Madrid',
            country: 'ES',
          },
        },
        image: '/static/img/Madrid.jpg',
        title: t('mainpage.popularDestinations.destinations.Madrid'),
      },
      {
        link: {
          path: `/search/G52.516,13.377`,
          query: {
            ...baseQuery.value,
            d: 'Berlin',
            type: 'city',
            lat: '52.516',
            lon: '13.376',
            city: 'Berlin',
            state: 'Berlin Federal State',
            country: 'DE',
          },
        },
        image: '/static/img/Berlin.jpg',
        title: t('mainpage.popularDestinations.destinations.Berlin'),
      },
      {
        link: {
          path: `/search/G52.230,21.009`,
          query: {
            ...baseQuery.value,
            d: 'Warsaw',
            type: 'city',
            lat: '52.229',
            lon: '21.008',
            city: 'Warsaw',
            state: 'Masovia',
            country: 'PL',
          },
        },
        image: '/static/img/Warsaw.jpg',
        title: t('mainpage.popularDestinations.destinations.Warsaw'),
      },
    ];
  });

  function setRegisterDialogShown() {
    store.commit('user/setRegisterDialogShown', true);
  }

return (_ctx: any,_cache: any) => {
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_unref(userV2) && _unref(userCategory) === _unref(User).UserCategory.Category.Individual)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", null, [
                  _createElementVNode("h2", _hoisted_5, _toDisplayString(_unref(t)('mainpage.freeCredits.title')), 1),
                  _createVNode(_component_i18n_t, {
                    class: "p-product-home--layout-subtitle regular grey",
                    keypath: "mainpage.freeCredits.subtitle",
                    tag: "p",
                    scope: "global"
                  }, {
                    credits: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  })
                ]),
                (!_unref(isMobile))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createVNode(_unref(ButtonComponent), {
                        class: "no-shadow border-radius-lg",
                        variant: "secondary",
                        onClick: setRegisterDialogShown
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('signUp')), 1)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("img", {
                  src: "/static/img/free-credits.jpg",
                  alt: _unref(t)('mainpage.freeCredits.title')
                }, null, 8, _hoisted_9),
                _hoisted_10
              ]),
              (_unref(isMobile))
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createVNode(_unref(ButtonComponent), {
                      variant: "secondary",
                      class: "no-shadow border-radius-lg",
                      onClick: setRegisterDialogShown
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('signUp')), 1)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_12, [
      (_unref(userCategory) != _unref(User).UserCategory.Category.Individual)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("h2", _hoisted_16, _toDisplayString(_unref(t)('mainpage.usage.title')), 1),
                _createElementVNode("p", _hoisted_17, _toDisplayString(_unref(t)('mainpage.usage.subtitle')), 1),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _hoisted_22,
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(t)('mainpage.usage.steps.search.title')), 1),
                          _createElementVNode("p", _hoisted_25, _toDisplayString(_unref(t)('mainpage.usage.steps.search.subtitle')), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _hoisted_28,
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("span", _hoisted_30, _toDisplayString(_unref(t)('mainpage.usage.steps.book.title')), 1),
                          _createElementVNode("p", _hoisted_31, _toDisplayString(_unref(t)('mainpage.usage.steps.book.subtitle')), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _hoisted_34,
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("span", _hoisted_36, _toDisplayString(_unref(t)('mainpage.usage.steps.earnMoney.title')), 1),
                          _createElementVNode("p", _hoisted_37, _toDisplayString(_unref(t)('mainpage.usage.steps.earnMoney.subtitle')), 1)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_38, [
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _createVNode(PopularDestinationsContainerComponent, {
              title: _unref(t)('mainpage.popularDestinations.title'),
              subtitle: _unref(t)('mainpage.popularDestinations.subtitle'),
              destinations: (_unref(destinations) as any)
            }, null, 8, ["title", "subtitle", "destinations"])
          ])
        ])
      ]),
      (!_unref(isAppView) && _unref(userCategory) != _unref(User).UserCategory.Category.Individual)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("h2", _hoisted_44, _toDisplayString(_unref(t)('mainpage.hotelChains.title')), 1),
                  _createElementVNode("p", _hoisted_45, _toDisplayString(_unref(t)('mainpage.hotelChains.subtitle')), 1),
                  _createElementVNode("div", _hoisted_46, [
                    _createVNode(_unref(Swiper), {
                      slidesPerVie: 1,
                      spaceBetween: 42,
                      speed: 500,
                      loop: true,
                      modules: [_unref(EffectFade), _unref(Autoplay)],
                      effect: "fade",
                      autoplay: ({
                      delay: 3500,
                      disableOnInteraction: false,
                    } as any),
                      class: "carousel"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(SwiperSlide), null, {
                          default: _withCtx(() => [
                            _hoisted_47
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(SwiperSlide), null, {
                          default: _withCtx(() => [
                            _hoisted_48
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(SwiperSlide), null, {
                          default: _withCtx(() => [
                            _hoisted_49
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(SwiperSlide), null, {
                          default: _withCtx(() => [
                            _hoisted_50
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modules", "autoplay"])
                  ])
                ])
              ])
            ]),
            _createVNode(DataSecureDescriptionComponent)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    (!_unref(isAppView))
      ? (_openBlock(), _createBlock(_unref(FooterComponent), {
          key: 1,
          class: _normalizeClass({
      'border-top': _unref(userCategory) === _unref(User).UserCategory.Category.Individual,
    })
        }, null, 8, ["class"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})